import config from "config";

export const getHeaders = () => {
  const authUser = sessionStorage.getItem("authUser");
  const token = authUser ? JSON.parse(authUser).access_token : null;

  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};


export const getPaginationRange = (
  current: number,
  totalPages: number,
  delta = 2
): (number | string)[] => {
  const range: (number | string)[] = [];
  const rangeWithDots: (number | string)[] = [];
  let last: number | undefined = undefined;

  // Build the main range
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= current - delta && i <= current + delta)
    ) {
      range.push(i);
    }
  }

  // Insert dots when skipping pages
  for (let i of range) {
    if (last !== undefined) {
      if (typeof i === "number" && i - last === 2) {
        rangeWithDots.push(last + 1);
      } else if (typeof i === "number" && i - last !== 1) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(i);
    if (typeof i === "number") {
      last = i;
    }
  }

  return rangeWithDots;
};